"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2728],{

/***/ 42728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ LogRocketIntegration; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _helpers_misc_isScrapping__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31394);
/* harmony import */ var _hooks_useCookiesAccepted__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35756);
/* harmony import */ var logrocket__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19258);
/* harmony import */ var logrocket__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(logrocket__WEBPACK_IMPORTED_MODULE_3__);




function LogRocketIntegration(props) {
    var config = props.integrations;
    var cookies = (0,_hooks_useCookiesAccepted__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!_helpers_misc_isScrapping__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z && config && config.integrations && config.integrations.logRocketId && cookies) {
            logrocket__WEBPACK_IMPORTED_MODULE_3___default().init(config.integrations.logRocketId);
        }
    }, [
        config,
        cookies
    ]);
    return null;
};


/***/ })

}]);